// SymmetryXTask.js
import { InlineMath } from "react-katex";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";

export function generate() {
  const x = Math.floor(Math.random() * 11) - 5;

  let y;
  do {
    y = Math.floor(Math.random() * 11) - 5;
  } while (y === 0);

  return {
    type: "SymmetryXTask",
    data: { point: [x, y] },
    answer: [x, -y],
  };
}

export function renderTask(task) {
  const [x, y] = task.data.point;

  return (
    <p>
      Wyznacz współrzędne punktu symetrycznego do punktu{" "}
      <InlineMath math={`P=(${x},${y})`} /> względem osi{" "}
      <InlineMath math="OX" />.
    </p>
  );
}

export function renderAnswer(task) {
  if (!task.answer) return <i>(brak odpowiedzi)</i>;

  const [x, y] = task.answer;
  return <InlineMath math={`P' = (${x},\\ ${y})`} />;
}

export function renderExplanation({ data, answer }) {
  const [x, y] = data.point;
  const [rx, ry] = answer;

  return (
    <div style={{ marginBottom: "32px" }}>
      <p>
        Odbicie względem osi <InlineMath math={'OX'} /> zmienia znak współrzędnej{" "}
        <InlineMath math={'y'} />, pozostawiając <InlineMath math={'x'} /> bez zmian.
      </p>

      <p>
        <InlineMath math={`P = (${x}, ${y}) \\Rightarrow P' = (${rx}, ${ry})`} />
      </p>

      {/* Zamiast pionowego scrolla: dajemy wystarczającą wysokość i ukrywamy overflowY.
          Scroll poziomy zostaje (na telefonach/małych ekranach). */}
      <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
        <div
          style={{
            minWidth: 520,
            height: 430,       // ↑ większa wysokość, żeby nic nie było ucinane
            overflowY: "hidden" // ↑ brak pionowego scrolla w środku
          }}
        >
          <GraphViewer
            points={{
              P: { x, y },
              "P'": { x: rx, y: ry },
            }}
          />
        </div>
      </div>
    </div>
  );
}


/** Input: 2× FractionInput (tak jak w zadaniach referencyjnych) */
export function renderInput(_, userInput, setUserInput, disabled) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span>
          <InlineMath math={"x_{P'} ="} />
        </span>
        <FractionInput
          value={userInput?.x || ""}
          onChange={(val) => setUserInput({ ...userInput, x: val })}
          disabled={disabled}
          label={"x_{P'}"}
        />
      </div>

      <div className="flex items-center gap-2">
        <span>
          <InlineMath math={"y_{P'} ="} />
        </span>
        <FractionInput
          value={userInput?.y || ""}
          onChange={(val) => setUserInput({ ...userInput, y: val })}
          disabled={disabled}
          label={"y_{P'}"}
        />
      </div>
    </div>
  );
}

export function checkAnswer(task, userInput) {
  if (!userInput || typeof userInput !== "object") return false;

  const ux = userInput.x?.parsed;
  const uy = userInput.y?.parsed;

  if (ux == null || uy == null || Number.isNaN(ux) || Number.isNaN(uy)) return false;

  const [rx, ry] = task.answer;
  return ux === rx && uy === ry;
}

export function renderUserAnswer(userInput) {
  if (!userInput?.x?.raw || !userInput?.y?.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  const x = formatLatexPreview(userInput.x.raw, "x_{P'}");
  const y = formatLatexPreview(userInput.y.raw, "y_{P'}");

  return (
    <div style={{ marginTop: "0.5rem", textAlign: "left" }}>
      <div>
        <InlineMath math={x} />
      </div>
      <div style={{ marginTop: "0.5rem" }}>
        <InlineMath math={y} />
      </div>
    </div>
  );
}
